var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import moment from "moment";
import { captureCleverTabAnalytics } from "src/utils/analytics";
import { getDefaultDateFormat, getStockNameFromSearchData, getscripCode, openChartTab, } from "src/utils/methods";
import { ToastUtils } from "src/utils/toast-utils";
function chart_common(singleData, expiryList, expiry_index, symbol, exchType, selectedActivity) {
    return __awaiter(this, void 0, void 0, function* () {
        let expiry_date = "";
        if (expiryList.length > 0) {
            expiry_date =
                expiry_index.toString().length === 1
                    ? moment(expiryList[expiry_index.toString()])
                        .format("DD MMM YYYY")
                        .toUpperCase()
                    : moment(expiry_index.toString()).format("DD MMM YYYY").toUpperCase();
        }
        const payload = false;
        try {
            const result = yield getscripCode(`${symbol} ${expiry_date}`, "N", exchType);
            if (JSON.stringify(result) === "{}") {
                ToastUtils.error("Scrip Code not found");
                return;
            }
            const chartData = {
                fullName: result.Name,
                strikePrice: (result === null || result === void 0 ? void 0 : result.StrikeRate) ? Number(result === null || result === void 0 ? void 0 : result.StrikeRate) : undefined,
                exchange: result.Exch,
                exchangeType: result.ExchType,
                expiry: expiry_date,
                symbol: symbol.split(" ")[0],
                scripCode: result.ScripCode,
            };
            openChartTab(chartData);
            captureCleverTabAnalytics("Screen_Open", {
                Action: "Charts",
                Initiation_Screen: selectedActivity,
            });
        }
        catch (err) {
            console.error("Something went wrong!");
        }
    });
}
const addWatchlist_common = (singleData, expiryList, expiry_index, symbol, exchType, openedFrom) => __awaiter(void 0, void 0, void 0, function* () {
    let expiry_date = "";
    if (expiryList.length > 0) {
        expiry_date =
            expiry_index.toString().length === 1
                ? moment(expiryList[expiry_index.toString()])
                    .format("DD MMM YYYY")
                    .toUpperCase()
                : moment(expiry_index.toString()).format("DD MMM YYYY").toUpperCase();
    }
    let payload = false;
    try {
        const result = yield getscripCode(`${symbol} ${expiry_date}`, "N", exchType);
        if (JSON.stringify(result) === "{}") {
            ToastUtils.error("Scrip Code not found");
            return;
        }
        payload = {
            Exch: "N",
            ExchType: exchType,
            ScripCode: result.ScripCode,
            name: symbol,
            openedFrom: openedFrom,
        };
        return payload;
    }
    catch (err) {
        console.error("Something went wrong!");
        return false;
    }
});
const buySellCallBack_common = (isBasket, isBuy, singleData, expiryList, expiry_index, symbol, exchType, openedFrom) => __awaiter(void 0, void 0, void 0, function* () {
    let expiry_date = "";
    if (expiryList.length > 0) {
        expiry_date =
            expiry_index.toString().length === 1
                ? moment(expiryList[expiry_index.toString()])
                    .format("DD MMM YYYY")
                    .toUpperCase()
                : moment(expiry_index.toString()).format("DD MMM YYYY").toUpperCase();
    }
    let payload = false;
    try {
        const result = yield getscripCode(`${symbol} ${expiry_date}`, "N", exchType);
        if (JSON.stringify(result) === "{}") {
            ToastUtils.error("Scrip Code not found");
            return;
        }
        singleData.date = expiry_date;
        let name = "";
        if (singleData.date) {
            name = symbol + " " + getDefaultDateFormat(singleData.date);
        }
        else {
            name = symbol;
        }
        payload = {
            isBuy,
            name: getStockNameFromSearchData(result),
            exchange: result.Exch,
            exchangeType: result.ExchType,
            scripCode: result.ScripCode,
            lastTradePrice: singleData.ltp,
            previousClose: singleData.pClose ? singleData.pClose : 0,
            orderFor: "P",
            isBasket: isBasket,
            orderData: undefined,
            netPositionDetail: undefined,
            vttOrderDetail: undefined,
            openedFrom: openedFrom,
        };
        return payload;
    }
    catch (err) {
        console.error("Something went wrong!");
        return false;
    }
});
const getScripCodeFromExpiry = (symbol, expiry_date, exchType, type, strike) => __awaiter(void 0, void 0, void 0, function* () {
    if (expiry_date) {
        expiry_date = moment(expiry_date).format("DD MMM YYYY").toUpperCase();
    }
    try {
        const result = type && strike
            ? yield getscripCode(`${symbol} ${expiry_date} ${type} ${strike}`, "N", exchType)
            : yield getscripCode(`${symbol} ${expiry_date}`, "N", exchType);
        if (JSON.stringify(result) === "{}") {
            ToastUtils.error("Scrip Code not found");
            return;
        }
        let name = "";
        if (expiry_date) {
            name = symbol + " " + getDefaultDateFormat(expiry_date);
        }
        else {
            name = symbol;
        }
        let payload1 = false;
        payload1 = {
            name: getStockNameFromSearchData(result),
            exchange: result.Exch,
            exchangeType: result.ExchType,
            scripCode: result.ScripCode,
        };
        return payload1;
    }
    catch (err) {
        console.error("Something went wrong!");
    }
});
export { chart_common, addWatchlist_common, buySellCallBack_common, getScripCodeFromExpiry, };
